import { useContext } from "react";
import ToastContext from "../context/ToastContext";

export default function useToast() {
    const { ref } = useContext(ToastContext);
    
    const showError = (title, message) => {
        ref.current.show({ severity: 'error', summary: title, detail: message });
    }

    const showAxiosError = (e) => {
        console.log(e);
        if (e?.response?.data) {
            const data = e.response.data;
            const summary = data.title;
            const detail = data.messages?.join(';\n');
            ref.current.show({ severity: 'error', summary, detail });
            return;
        }
        if (e?.response?.status === 403) {
            ref.current.show({ severity: 'error', summary: 'Não autorizado', detail: 'Você não possui permissão para essa ação' });
            return;
        }
    }

    const showSuccess = (title, detail) => {
        ref.current.show({ severity: 'success', summary: title, detail });
    }

    return {
        showError,
        showAxiosError,
        showSuccess
    }
}